
import { Typography, Box, IconButton } from "@mui/material";
import { BoxFR } from "components/BoxCustom";
import ComboBox from "components/ComboBox";
import dayjs from "dayjs";
import React from "react";
import { useCallback } from "react";
import { useState } from "react";
import EditContStsTmDialog from "./EditContStsTmDialog";
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import { EditRounded, Schedule } from "@mui/icons-material";

const ContainerStatusItem = ({ msData, contStsData, setContStsData, options, setJobOrderData, onChange, hideDriverActTm, hideIsCmpt }) => {

  const [dialogOpen, setDialogOpen] = useState(false)

  const handleChangeStsTm = useCallback((newValue) => {
    contStsData.StsTm = newValue
    setContStsData(oldData => [...oldData])
  }, [contStsData, setContStsData])

  const handleOpenDialog = useCallback(() => {
    setDialogOpen(true)
  }, [])

  const handleIsCmptClick = useCallback((e) => {
    contStsData.IsCmpt = contStsData.IsCmpt === 1 ? 0 : 1
    setContStsData(oldData => [...oldData])
  }, [contStsData, setContStsData])

  // console.log("in render ContainerStatusItem setJobOrderData::", setJobOrderData)
  return (
    <Box gap={1} sx={{
      padding: 1,
      display: "flex",
      flexDirection: "column",
      bgcolor: contStsData.DrvId && `${contStsData.BgClr}.main`,
      border: "2px solid ",
      borderColor: `${contStsData.BgClr}.main`,
      borderRadius: 2,
      height: 92,
      flex: 1
    }}>
      <BoxFR>
        <Typography color={contStsData.DrvId && "#FFFFFF"}>{contStsData.Name} </Typography>
        <Box flex={1} />
        {hideDriverActTm ? null :
          <BoxFR sx={{ gap: 0.5 }}>
            <Schedule sx={{ px: 0, mx: 0, color: contStsData.DrvId ? "white" : "black" }} />
            <Typography color={contStsData.DrvId && "#FFFFFF"}>{contStsData.StsTm ? dayjs(contStsData.StsTm).format("DD/MM HH:mm") : "วัน-เวลา"}</Typography>
            <IconButton sx={{ p: 0 }} onClick={handleOpenDialog}>
              <EditRounded sx={{ px: 0, mx: 0, color: contStsData.DrvId ? "white" : "black" }} />
            </IconButton>
          </BoxFR>
        }
      </BoxFR>
      <BoxFR display="flex" gap={1}>
        <ComboBox sx={{ flexGrow: 1 }} options={options || msData.driverCombo} required={false}
          selectedId={contStsData.DrvId}
          setSelectedId={(id) => {
            const tukId = msData.drivers.find(drv => drv.DrvId === id)?.TukId || null
            contStsData.DrvId = id;
            contStsData.StsTm = id ? dayjs() : null
            contStsData.TukId = tukId
            setContStsData(oldData => [...oldData])
            if (setJobOrderData) {
              setJobOrderData(o => ({
                ...o,
                DrvId: id,
                DrvActTm: id === null ? null : dayjs(),
                TukId: tukId
              }))
            }
            if (onChange) {
              onChange(id)
            }
          }}
        />
        <ComboBox sx={{ flexGrow: 1 }} options={msData.truckCombo} required={false}
          selectedId={contStsData.TukId}
          setSelectedId={(id) => {
            contStsData.TukId = id;
            setContStsData(oldData => [...oldData])
            if (setJobOrderData) {
              setJobOrderData(o => ({
                ...o,
                TukId: id
              }))
            }
          }}
        />
        {hideIsCmpt ? null :
          <IconButton sx={{ p: 0.5, backgroundColor: "white" }} onClick={handleIsCmptClick} disabled={contStsData.DrvId ? false : true}>
            <FactCheckRoundedIcon color={contStsData.IsCmpt === 1 ? "success" : "inherit"} />
          </IconButton>
        }

      </BoxFR>
      <EditContStsTmDialog dialogOpen={dialogOpen} setDialogOpen={setDialogOpen} initValue={dayjs(contStsData.StsTm)} setContStsTm={handleChangeStsTm} />
    </Box>
  )
}

export default ContainerStatusItem